import { Link } from 'react-router-dom'

function Footer() {
    return(
        <footer className='text-center items-center mt-10 h-10 bg-white flex justify-center'>
            <p className='font-sans'>Designed by <a href='#' className='font-sans hover:text-amber-700'>Supun Nisala</a></p>
        </footer>
    )
}

export default Footer;